import logo from "../assets/logo.jpg";

export const Settings = {
  title: "重庆园业实业后台",
  logo: logo,
};